import DeviceCard from "./DeviceCard";
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'
import Pill_Widget from "../../Widgets/Pill_Widget";
import { format } from "date-fns";
import signal100 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/signal_100.png'
import signal75 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/signal_75.png'
import signal50 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/signal_50.png'
import signal25 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/signal_25.png'
import signal0 from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/signal_0.png'
import areYouSure from '../../../../assets/animations/areYouSure.json'
import Lottie from "lottie-react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { unlinkGateway } from "../../../../Api Methods/Api";
import { useDispatch } from "react-redux";

const GatewayCard = ({gateway, apiData, siteUUID, showSuccess, refreshDevices}) => {

    console.log(gateway)
    const lastSeen = new Date(gateway.lastSeenAt)
    const linked = new Date(gateway.dateLinked)
    const lastSeenFormatted = format(lastSeen, "MMM do, yyyy")
    const linkedFormatted = format(linked, "MMM do, yyyy")
    const [showConfirm, setShowConfirm] = useState(false)
    const dispatch = useDispatch();
    
    const unlink = async () => {
        const responseData = await unlinkGateway(apiData, siteUUID, gateway.id, dispatch)
        if (responseData) {
            setShowConfirm(false)
            showSuccess(true)
            refreshDevices()
        }    
    }

    const batteryColours = (batteryLevel) => {
        let colour = "";
        if (batteryLevel >= 0 && batteryLevel < 25) {
            // red
            colour = "rgb(220,114,119)"
        } else if (batteryLevel >= 25 && batteryLevel < 50) {
            //orange
            colour = "rgb(248,183,131)"
        } else {
            //green
            colour = "rgb(101,151,100)"
        }

        return colour;
    }

    const signalIcons = [
        signal100, 
        signal75, 
        signal50, 
        signal25, 
        signal0
    ]

    let signalIcon;

    if (gateway.signal >= 75){
        signalIcon = signalIcons[0]
    } else if (gateway.signal >= 50 && gateway.signal < 75){
        signalIcon = signalIcons[1]
    } else if (gateway.signal >= 25 && gateway.signal < 50){
        signalIcon = signalIcons[2]
    } else if (gateway.signal >= 0 && gateway.signal < 25){
        signalIcon = signalIcons[3]
    } else {
        signalIcon = signalIcons[4]
    }
    
    return (
        <>

        <Dialog
            header="Are you sure?"
            visible={showConfirm}
            style={{ width: "40vw" }}
            onHide={() => setShowConfirm(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSure}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this Gateway?`}</h3>
                <br />
                <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setShowConfirm(false)} />
                <br />
                <Button label="Yes, unlink" rounded icon="pi pi-check" severity="danger" onClick={() => unlink()} />

            </div>
        </Dialog>
        
        <DeviceCard
            header={`Gateway`}
            meta={[gateway.IMEI, `Linked: ${linkedFormatted}`, `Last updated: ${linkedFormatted}`]}
            rightContent={
                <>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        gap:"5px"
                    }}>
                        <Pill_Widget boolean={true} PillColor_IfTrue={batteryColours(gateway.battery)} PillColor_IfFalse={"#626a67"} text_IfTrue={gateway.battery + "%"} />
                        <img src={signalIcon} style={{width:"25px"}} />
                    </div>
                    
                    <img src={removeIcon} style={{width:"25px", cursor:"pointer"}} onClick={() => setShowConfirm(true)}/>
                </>
            } 
        />
    </>
    );
}

export default GatewayCard;